<div class="rn-page">
  <div class="rn-page__section">
    @if (isLoading()) {
      <div class="rn-page--busy">
        <app-spinner></app-spinner>
      </div>
    }
    @if (this.currentHoursType && this.currentHoursType !== 'BUSINESS_HOURS' && !this.isErrorClientStatus && this.currentHoursExpires) {
      <div class="help-text-container">
        <p>
          The {{ this.currentHoursType === 'AFTER_HOURS' ? 'After Hours' : 'Out of Office'}} auto response is enabled until {{ this.currentHoursExpires }}. Your business hours and other auto responses will resume then.
        </p>
      </div>
    }
    @if (this.currentHoursType && this.currentHoursType !== 'BUSINESS_HOURS' && !this.isErrorClientStatus && !this.currentHoursExpires) {
      <div class="help-text-container">
        <p>
          The {{ this.currentHoursType === 'AFTER_HOURS' ? 'After Hours' : 'Out of Office'}} auto response is enabled indefinitely. Update your business hours to reflect availability in Relay Messenger.
        </p>
      </div>
    }
    @if (isErrorBusinessHours) {
      <div>
        <p class="business-hours-error-msg">
          Oops, there was an error loading this page. Please try refreshing.
        </p>
      </div>
    }
  </div>

  @if (businessHoursGroup) {
    <form [formGroup]="businessHoursGroup" class="business-hours-form">
      <h3>Business Hours</h3>
      <p>
        Please set the hours your team will be available in Relay Messenger. All
        times are shown in Eastern time.
      </p>
      <div class="business-hours-container" [class.disabled]="isOutOfOfficeEnabled">
        @for (day of days; track day) {
          <div [formGroupName]="day">
            <div class="day-row">
              <app-radio-btn
                [btnLabel]="day"
                [btnWidth]="'211px'"
                [btnName]="day + '-enabled'"
                [btnModel]="businessHoursGroup.get(day + '.enabled')?.value"
                [btnDisplayTrueFirst]="true"
                (btnModelChange)="toggleDay(day)"
                style="text-transform: capitalize"
              ></app-radio-btn>
              <!-- Start Time Picker -->
              <mat-form-field appearance="outline" class="start-time">
                <input
                  matInput
                  [matTimepicker]="startPicker"
                  formControlName="startTime"
                  [disabled]="outOfOfficeEnabled"
                  />
                <mat-timepicker-toggle matSuffix [for]="startPicker">
                  <mat-icon matTimepickerToggleIcon>keyboard_arrow_down</mat-icon>
                </mat-timepicker-toggle>
                <mat-timepicker #startPicker></mat-timepicker>
                @if (
                  businessHoursGroup
                  .get(day + '.startTime')
                  ?.hasError('required')
                  ) {
                  <mat-error
                    >
                    Required
                  </mat-error>
                }
                @if (
                  businessHoursGroup
                  .get(day + '.startTime')
                  ?.hasError('invalidDate')
                  ) {
                  <mat-error
                    >
                    Invalid time format
                  </mat-error>
                }
              </mat-form-field>
              <span>TO</span>
              <!-- End Time Picker -->
              <mat-form-field appearance="outline">
                <input
                  matInput
                  [matTimepicker]="endPicker"
                  formControlName="endTime"
                  [disabled]="outOfOfficeEnabled"
                  />
                <mat-timepicker-toggle matIconSuffix [for]="endPicker">
                  <mat-icon matTimepickerToggleIcon>keyboard_arrow_down</mat-icon>
                </mat-timepicker-toggle>
                <mat-timepicker #endPicker></mat-timepicker>
                @if (
                  businessHoursGroup.get(day + '.endTime')?.hasError('required')
                  ) {
                  <mat-error
                    >
                    Required
                  </mat-error>
                }
                @if (
                  businessHoursGroup
                  .get(day + '.endTime')
                  ?.hasError('invalidDate')
                  ) {
                  <mat-error
                    >
                    Invalid time format
                  </mat-error>
                }
              </mat-form-field>
              @if (businessHoursGroup.get(day)?.hasError('startAfterEnd')) {
                <mat-error
                  class="err-msg-start-time"
                  >
                  Start time must be before end time
                </mat-error>
              }
            </div>
          </div>
        }
      </div>
      <div class="enable-out-of-office" formGroupName="outOfOffice">
        <app-radio-btn
          [btnLabel]="'Enable Out of Office Auto Response'"
          [btnWidth]="'370px'"
          [btnName]="'enable-out-of-office'"
          [btnDisplayTrueFirst]="true"
          [btnModel]="isOutOfOfficeEnabled"
          (btnModelChange)="toggleOutOfOffice()"
        ></app-radio-btn>
        <div>
          <p style="margin-bottom: 0;">
            Customers will receive the Out of Office response when this is enabled.
          </p>
          <p class="override-business-hours-disclaimer">This will override business hours and any other auto responses until disabled.</p>
        </div>
        @if (isOutOfOfficeEnabled) {
          <div style="margin-left: 31px;">
            <p class="end-holiday-text">End Holiday Auto Response:</p>
            <mat-form-field
              appearance="outline"
              class="out-of-office-date-picker"
              >
              <input matInput [matDatepicker]="picker"
                formControlName="expirationDate"
                placeholder="Select Date"
                [min]="minDate"
                [max]="maxDate" />
              <mat-datepicker-toggle [for]="picker" matPrefix></mat-datepicker-toggle>
              <mat-datepicker #picker />
            </mat-form-field>
            <mat-form-field appearance="outline" class="out-of-office-date-picker">
              <input
                matInput
                [matTimepicker]="outOfOfficePicker"
                formControlName="expirationTime"
                />
              <mat-timepicker-toggle matIconSuffix [for]="outOfOfficePicker">
                <mat-icon matTimepickerToggleIcon>keyboard_arrow_down</mat-icon>
              </mat-timepicker-toggle>
              <mat-timepicker #outOfOfficePicker></mat-timepicker>
            </mat-form-field>
            <div style="margin-top: 10px;">
              <p>Your hours of operation and other auto responses will resume at this date and time.</p>
              @if (isInErrorState()) {
                <span
                  class="error-msg"
                  >
                  <i class="fa fa-exclamation-circle error-icon-position" aria-hidden="true"></i>
                  Please select a date for your Out of Office auto response to end.
                </span>
              }
              @if (isTimeSelectedInThePast()) {
                <span
                  class="error-msg"
                  >
                  The time selected is in the past. Please select a future time.
                </span>
              }
            </div>
          </div>
        }
      </div>
    </form>
  }

  <div class="button-container">
    <button
      class="btn btn-primary"
      id="next-btn"
      (click)="saveAndContinue()"
      [disabled]="!businessHours || businessHoursGroup.invalid || isInErrorState() || (isOutOfOfficeEnabled && isTimeSelectedInThePast())"
      >
      <span
        i18n="Label for Next button on new client configuration"
        id="save-and-next-button"
        >
        Save and Next
      </span>
      <span class="icon icon-right">
        <i class="fa fa-arrow-right"></i>
      </span>
    </button>
  </div>
</div>

<message-dialog #messageDialog [showCancel]="false"></message-dialog>
